import { PageContent } from "component/PageContent"
import { PageLayout } from "component/PageLayout"
import { TitleBarStats } from "component/TitleBarStats"

import { Landing } from "./Landing"

const PageWelcome = () => {
    return (
        <PageLayout maxW="1020px" backgroundPosition="30% -400px" backgroundRepeat="no-repeat" pb="0px">
            <PageContent pt={[10, 0]} pb={[0, "200px"]}>
                <Landing />
            </PageContent>
            <TitleBarStats />
        </PageLayout>
    )
}

export default PageWelcome
